import { useEffect } from 'react'
import { useAtom } from 'jotai'
import { useOutletContext } from 'react-router-dom'
import { purchaseTypeAtom } from '@!/atoms/paymentAtom'
import { VStack, Divider } from '@chakra-ui/react'
import { PaymentCoinListRow } from '@!/User/Payment/components'

export const PaymentCoinList = () => {
  const { paymentList, onCoinSelect } = useOutletContext()
  const [, setPurchaseType] = useAtom(purchaseTypeAtom)

  useEffect(() => {
    setPurchaseType('coin')
  }, [])

  return (
    <VStack py="8px" borderY="1px" borderColor="divider.light" divider={<Divider spacing={0} />}>
      {paymentList.map((value, index) => (
        <PaymentCoinListRow
          key={`payment-coin-list-row-${index}`}
          coin={value[0]}
          price={value[1]}
          attention={value[2]}
          index={index}
          handleClickCoin={() => onCoinSelect(index)}
        />
      ))}
    </VStack>
  )
}
